import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import { ArrowLeft } from "lucide-react";
import { API } from "@/lib/api";

export default function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [missing, setMissing] = useState(false);
  useEffect(() => { axios.get(`${API}/blog/${slug}`).then((r) => setPost(r.data)).catch(() => setMissing(true)); }, [slug]);

  if (missing) return <div className="py-24 text-center" data-testid="blog-post-missing">Article not found. <Link to="/blog" className="text-teal-700 underline">Back to tips</Link></div>;
  if (!post) return <div className="py-24 text-center text-slate-500">Loading...</div>;
  return (
    <article className="mx-auto max-w-3xl px-6 py-14" data-testid="blog-post-page">
      <Link to="/blog" className="inline-flex items-center gap-2 text-sm font-bold text-teal-700" data-testid="blog-back-link"><ArrowLeft className="h-4 w-4" />All tips</Link>
      <span className="mt-6 block w-fit rounded-full bg-[#fef7e5] px-3 py-1 text-xs font-bold text-slate-700">{post.category}</span>
      <h1 className="mt-4 text-4xl font-bold leading-tight tracking-tight sm:text-5xl" data-testid="blog-post-title">{post.title}</h1>
      {post.cover && <img src={post.cover} alt="" className="mt-8 h-80 w-full rounded-[2rem] object-cover" />}
      <div className="mt-8 space-y-5 text-lg leading-relaxed text-slate-700">
        {post.content.split(/\n\s*\n/).map((para, i) => <p key={i}>{para}</p>)}
      </div>
      <Link to="/book" data-testid="blog-book-cta" className="btn-pop shadow-chunky-coral mt-12 inline-block rounded-full bg-[#ff6b6b] px-7 py-4 font-bold text-white">Book a check-up</Link>
    </article>
  );
}
